import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanService } from '../../shared-component/service/loan/loan.service';
import { HelperService } from '../../shared-component/service/helper/helper.service';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-residence-details',
  templateUrl: './residence-details.component.html',
  styleUrls: ['./residence-details.component.scss']
})
export class ResidenceDetailsComponent implements OnInit {

  public residenceDetail: FormGroup;
  private loanId: number;
  public oldFormData: any;

  public states: any = [];
  public cities: any = [];
  public cKycDetails: any = '';
  public resData: any;
  public cKycAddressDetails: any;
  public curDifPar: any = false;

  public showFullAddress: boolean = false;
  public showAlternateFullAddress: boolean = false;

  public correspondingAddress = [{
    name: 'residenceHouseNo',
    pattern: /^[a-zA-Z0-9\s#,.'-\/]{3,}$/
  }, {
    name: 'residenceBuildingName',
    pattern: /^[a-zA-Z0-9\s#,.'-\/]{3,}$/
  }, {
    name: 'residenceAddressLine1',
    pattern: /^[a-zA-Z0-9\s#,.'-\/]{3,}$/
  }, {
    name: 'residenceAddressLine2',
    pattern: /^[a-zA-Z0-9\s#,.'-\/]{3,}$/
  }, {
    name: 'residenceLandMark',
    pattern: /^[a-zA-Z0-9\s#,.'-\/]{3,}$/
  }, {
    name: 'residenceState',
    pattern: /^[a-zA-Z\s]{3,}$/
  }, {
    name: 'residenceCity',
    pattern: /^[a-zA-Z\s]{3,}$/
  }, {
    name: 'residencePincode',
    pattern: /^[0-9]{6}$/
  }
  ];

  constructor(
    public fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    public router: Router,
    private loanService: LoanService,
    private helperService: HelperService
  ) {
  }

  ngOnInit() {
    this.activeRoute.data.subscribe((res: any) => {
      this.resData = res;
      this.cKycDetails = JSON.parse(res.loanDetail.cKycReport.cKyc);
      if (this.cKycDetails && this.cKycDetails.download_response) {
        if (this.cKycDetails.download_response.personal_details.perm_corr_same_flag == 'N') {
          this.curDifPar = true;
        } else {
          this.curDifPar = false;
        }
      }
    })

    this.residenceDetail = this.fb.group({
      houseNo: ['', Validators.compose([Validators.required])],
      buildingName: ['', Validators.compose([Validators.required , Validators.minLength(5) , this.validateSingleSpaceOnly])],
      addressLine1: ['', Validators.compose([Validators.required])],
      addressLine2: [''],
      landMark: ['', Validators.compose([Validators.required , Validators.minLength(10),this.validateSingleSpaceOnly])],
      state: ['', Validators.compose([Validators.required])],
      city: ['', Validators.compose([Validators.required])],
      tier: ['', Validators.compose([Validators.required])],
      pincode: ['', Validators.compose([Validators.required, Validators.pattern(/^[0-9]{6}$/)])],
      residentAddressDifferentFromPermanent: [this.curDifPar]
    });

    this.pincode.valueChanges.subscribe((res: any) => {
      if (this.pincode.value && this.pincode.value.toString().length === 6)
        this.showCityState();
      else {
        this.city.setValue(null);
        this.tier.setValue(null);
        this.state.setValue(null);
      }
    });

    this.isDifferentAddress.valueChanges.subscribe((res) => {
      if (res) {
        this.correspondingAddress.forEach((o) => {
          if (!this.residenceDetail.get(o.name)) {
            let validation = [Validators.required];
            if (o.pattern) {
              validation.push(Validators.pattern(o.pattern));
            }
            this.residenceDetail.addControl(o.name,
              new FormControl('', Validators.compose(validation)));

            if (o.name === 'residencePincode') {
              this.residenceDetail.get(o.name)
                .setValidators([Validators.required, Validators.pattern(/^[0-9]{6}$/)])
            }
          }
        });

        this.residencePincode.valueChanges.subscribe(() => {
          if (this.residencePincode.value && this.residencePincode.value.toString().length === 6)
            this.showAlternateCityState();
          else {
            this.residenceCity.setValue(null);
            this.residenceState.setValue(null);
          }
        });

      } else {
        this.correspondingAddress.forEach((o) => {
          if (this.residenceDetail.get(o.name)) {
            this.residenceDetail.removeControl(o.name);
          }
        });
      }
    });

    if (this.resData.loanDetail && Object.keys(this.resData.loanDetail).length) {
      // removing this condition as if there's cKyc data, it'll be passed in the forms
      // but the cKyc data is inconsistence, hence not passsing it in form
      if (this.cKycDetails && this.cKycDetails.download_response) {
        this.cKycAddressDetails = this.cKycDetails.download_response.personal_details
      } else {
        this.cKycAddressDetails = ''
      }
      this.loanId = this.resData.loanDetail.id;
      this.oldFormData = this.resData.loanDetail;

      if (this.resData.loanDetail.Customer) {
        this.residenceDetail.patchValue({
          residentAddressDifferentFromPermanent: this.curDifPar ? this.curDifPar : this.resData.loanDetail.Customer.residentAddressDifferentFromPermanent,
          houseNo: this.resData.loanDetail.Customer.houseNo ? this.resData.loanDetail.Customer.houseNo : '',
          buildingName: this.resData.loanDetail.Customer.buildingName ? this.resData.loanDetail.Customer.buildingName : '',
          addressLine1: this.cKycAddressDetails.perm_line1 ? this.cKycAddressDetails.perm_line1 : this.resData.loanDetail.Customer.addressLine1,
          addressLine2: this.cKycAddressDetails.perm_line2 ? this.cKycAddressDetails.perm_line2 : this.resData.loanDetail.Customer.addressLine2,
          landMark: this.cKycAddressDetails.perm_line3 ? this.cKycAddressDetails.perm_line3 : this.resData.loanDetail.Customer.landMark,
          state: this.resData.loanDetail.Customer.state ? this.resData.loanDetail.Customer.state : '',
          city: this.resData.loanDetail.Customer.city ? this.resData.loanDetail.Customer.city : '',
          tier: this.resData.loanDetail.Customer.tier ? this.resData.loanDetail.Customer.tier : '',
          pincode: this.cKycAddressDetails.perm_pin ? this.cKycAddressDetails.perm_pin : this.resData.loanDetail.Customer.pincode,
        });
        if (this.curDifPar || this.resData.loanDetail.Customer.residentAddressDifferentFromPermanent) {
          this.residenceDetail.patchValue({
            residentAddressDifferentFromPermanent: this.curDifPar ? this.curDifPar : this.resData.loanDetail.Customer.residentAddressDifferentFromPermanent,
            residenceHouseNo: this.resData.loanDetail.Customer.residentHouseNo ? this.resData.loanDetail.Customer.residentHouseNo : '',
            residenceBuildingName: this.resData.loanDetail.Customer.residentBuildingName ? this.resData.loanDetail.Customer.residentBuildingName : '',
            residenceAddressLine1: this.cKycAddressDetails.corr_line1 ? this.cKycAddressDetails.corr_line1 : this.resData.loanDetail.Customer.residentAddressLine1,
            residenceAddressLine2: this.cKycAddressDetails.corr_line2 ? this.cKycAddressDetails.corr_line2 : this.resData.loanDetail.Customer.residentAddressLine2,
            residenceLandMark: this.cKycAddressDetails.corr_line3 ? this.cKycAddressDetails.corr_line3 : this.resData.loanDetail.Customer.residentLandMark,
            residenceState: this.resData.loanDetail.Customer.residentState ? this.resData.loanDetail.Customer.residentState : '',
            residenceCity: this.resData.loanDetail.Customer.residentCity ? this.resData.loanDetail.Customer.residentCity : '',
            residencePincode: this.cKycAddressDetails.corr_pin ? this.cKycAddressDetails.corr_pin : this.resData.loanDetail.Customer.residentPincode
          });
        }
      }

    }
  }

  get houseNo() {
    return this.residenceDetail.get('houseNo');
  }

  get buildingName() {
    return this.residenceDetail.get('buildingName');
  }

  get addressLine1() {
    return this.residenceDetail.get('addressLine1');
  }

  get addressLine2() {
    return this.residenceDetail.get('addressLine2');
  }

  get landMark() {
    return this.residenceDetail.get('landMark');
  }

  get state() {
    return this.residenceDetail.get('state');
  }

  get city() {
    return this.residenceDetail.get('city');
  }

  get tier() {
    return this.residenceDetail.get('tier');
  }

  get pincode() {
    return this.residenceDetail.get('pincode');
  }

  validateSingleSpaceOnly(control: AbstractControl): ValidationErrors | null {
    const val = (control.value || '') as string;
    const spaces = val.split(' ').length - 1;
    return spaces > 1 ? { tooManySpaces: true } : null;
  }

  get isDifferentAddress() {
    return this.residenceDetail.get('residentAddressDifferentFromPermanent');
  }

  get residenceHouseNo() {
    return this.residenceDetail.get('residenceHouseNo');
  }

  get residenceBuildingName() {
    return this.residenceDetail.get('residenceBuildingName');
  }

  get residenceAddressLine1() {
    return this.residenceDetail.get('residenceAddressLine1');
  }

  get residenceAddressLine2() {
    return this.residenceDetail.get('residenceAddressLine2');
  }

  get residenceLandMark() {
    return this.residenceDetail.get('residenceLandMark');
  }

  get residenceState() {
    return this.residenceDetail.get('residenceState');
  }

  get residenceCity() {
    return this.residenceDetail.get('residenceCity');
  }

  get residencePincode() {
    return this.residenceDetail.get('residencePincode');
  }

  onSubmit() {
    let data = {
      houseNo: this.capitalize(this.houseNo.value),
      buildingName: this.capitalize(this.buildingName.value),
      addressLine1: this.capitalize(this.addressLine1.value),
      addressLine2: this.capitalize(this.addressLine2.value),
      landMark: this.capitalize(this.landMark.value),
      pincode: this.pincode.value,
      tier: this.tier.value,
      residentAddressDifferentFromPermanent: false,
    };

    if (this.isDifferentAddress.value) {
      if (this.oldFormData.Customer.residenceHouseNo !== this.residenceHouseNo.value)
        data['residenceHouseNo'] = this.capitalize(this.residenceHouseNo.value);

      if (this.oldFormData.Customer.residenceBuildingName !== this.residenceBuildingName.value)
        data['residenceBuildingName'] = this.capitalize(this.residenceBuildingName.value);

      if (this.oldFormData.Customer.residenceAddressLine1 !== this.residenceAddressLine1.value)
        data['residenceAddressLine1'] = this.capitalize(this.residenceAddressLine1.value);

      if (this.oldFormData.Customer.residenceAddressLine2 !== this.residenceAddressLine2.value)
        data['residenceAddressLine2'] = this.capitalize(this.residenceAddressLine2.value);

      if (this.oldFormData.Customer.residenceLandMark !== this.residenceLandMark.value)
        data['residenceLandMark'] = this.capitalize(this.residenceLandMark.value);

      if (this.oldFormData.Customer.residencePincode !== this.residencePincode.value)
        data['residencePincode'] = this.residencePincode.value;

      if (Object.keys(data).includes('residenceAddress') ||
        Object.keys(data).includes('residencePincode')
      ) {
        data['residentAddressDifferentFromPermanent'] = true;
      }
    }

    this.loanService.address(data, this.loanId).subscribe(() => {
      this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/employeeDetails`);
    }, (errors) => {
      for (let error of errors) {
        if (!this.residenceDetail.get(error.field)) continue;
        this.residenceDetail.get(error.field).setErrors({ server: error.message });
      }
    });
  }

  goPrev() {
    this.router.navigateByUrl(`/loanApplication/newLoanProcess/${this.loanId}/details`);
  }

  showCityState() {
    if (this.pincode.value && this.pincode.value.toString().length === 6) {
      this.helperService.getPincodes(this.pincode.value).subscribe((res: any) => {
        if (res.data) {
          this.city.setValue(res.data.cityName);
          this.tier.setValue(res.data.tier);
          this.state.setValue(res.data.stateName);
          this.showFullAddress = true;
        }
        else {
          this.pincode.setErrors({
            'server': 'Please provide valid Pincode'
          });
        }
      });
    }
  }

  showAlternateCityState() {
    if (this.residencePincode.value && this.residencePincode.value.toString().length === 6) {
      this.helperService.getPincodes(this.residencePincode.value).subscribe((res: any) => {
        if (res.data) {
          this.residenceCity.setValue(res.data.cityName);
          this.residenceState.setValue(res.data.stateName);
          this.showAlternateFullAddress = true;
        }
        else {
          this.residencePincode.setErrors({
            'server': 'Please provide valid Pincode'
          });
        }
      });
    }
  }
  capitalize(input) {
    if (input && input.trim()) {
      const trimmedInput = input.trim();
      const inputSplitBySpace = trimmedInput.split(" ");
      const capitalizedInputList = inputSplitBySpace.reduce((acc, val) => {
        return val ? acc.concat([val[0].toUpperCase() + val.slice(1, val.length)]) : acc;
      }, []);
      return capitalizedInputList.join(" ");
    }
    return input;
  }
}
